import React from "react";

const ItemExternal = ({
  item,
  setSsoRefreshTokenModal,
  setActiveSidebar,
  refreshToken,
}) => (
  <>
    <a
      target="_blank"
      href={!item.sso ? item.link : undefined}
      onClick={() => {
        if (item.sso) {
          refreshToken(item.link);
          setActiveSidebar(false);
          setSsoRefreshTokenModal(true);
        }
      }}
      style={
        item.sso
          ? { color: "inherit", cursor: "pointer" }
          : { color: "inherit" }
      }
      className="list-group-item border-0 text-decoration-none py-3"
    >
      {item.title}
    </a>
  </>
);

export default ItemExternal;
